import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7a5ecbda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-float-label p-mt-4" }
const _hoisted_2 = { for: "name" }
const _hoisted_3 = { class: "p-float-label p-mt-5" }
const _hoisted_4 = { for: "description" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      type: "button",
      label: _ctx.$t('terminal.newTerminal'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = true)),
      icon: "pi pi-plus",
      class: "p-mr-2"
    }, null, 8, ["label"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('terminal.newTerminal'),
      visible: _ctx.dialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog) = $event)),
      breakpoints: { '960px': '75vw' },
      style: { width: '30vw' },
      modal: true,
      closable: "",
      "close-on-escape": "",
      onShow: _cache[6] || (_cache[6] = ($event: any) => (_ctx.input.name = 'TERMINAL ' + _ctx.number))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('close'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialog = false)),
          icon: "pi pi-close",
          class: "p-button-warning"
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: _ctx.$t('save'),
          loading: _ctx.createLoading,
          disabled: _ctx.createLoading,
          onClick: _ctx.createTerminal,
          icon: "pi pi-save",
          "icon-pos": "right"
        }, null, 8, ["label", "loading", "disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_InputText, {
            disabled: true,
            id: "name",
            type: "text",
            modelValue: _ctx.input.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.name) = $event)),
            style: {"width":"100%"}
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("product.name")), 1)
        ]),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_Textarea, {
            autoResize: true,
            rows: "3",
            cols: "30",
            id: "description",
            style: {"width":"100%"},
            modelValue: _ctx.input.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.description) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("terminal.description")), 1)
        ]),
        _hoisted_5,
        _createVNode(_component_SelectButton, {
          modelValue: _ctx.input.active,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.input.active) = $event)),
          options: _ctx.status,
          optionLabel: "label",
          "option-value": "value"
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}